import momentTimezone from 'moment-timezone'

import { dateToString } from 'modules/core/lib/dates'

import employees from 'modules/employees/store/collections/employees'
import type Employee from 'modules/employees/store/models/Employee'
import { employeeLocation } from 'modules/locations/store/collections/locations'
import type ShiftConflict from 'modules/shift_management/store/internal/models/ShiftConflict'

const findEmployee = (sc: ShiftConflict): Employee | undefined => {
  return employees.find({ id: sc.employeeId })
}

const employeeTimeZone = (sc: ShiftConflict): string | null | undefined => {
  const employee = findEmployee(sc)
  return employee ? employeeLocation(employee.attributes.location_id)?.timezone : null
}

const startAtWithTZ = (sc: ShiftConflict): momentTimezone.Moment => {
  return momentTimezone.tz(sc.startAt, employeeTimeZone(sc) ?? '')
}

const currentStartDate = (sc: ShiftConflict): moment.Moment => {
  return !employeeTimeZone(sc) ? sc.startAt : startAtWithTZ(sc)
}

const shiftConflictIsDate = (sc: ShiftConflict, date: moment.Moment): boolean => {
  return dateToString(currentStartDate(sc), 'backend') === dateToString(date, 'backend')
}

export { shiftConflictIsDate }
